<template>
  <div class="introduction" >
    <div class="img-box">
      <img v-lazy="cover" />
      <div class="background">
        <span class="title">{{title}}</span>
        <div class="bottom">
          <div class="group">
            <span class="number">
              <span>{{getSubsectionCount}}</span>节
            </span>
            <span>总节数</span>
          </div>
          <div class="group">
            <span class="number">
              <span>{{students}}</span>人
            </span>
            <span>学习过</span>
          </div>
        </div>
      </div>
    </div>
    <div class="panel-box">
      <h4 class="header">{{title}}</h4>
      <span>{{details}}</span>
    </div>
    <div class="panel-box">
      <h4 class="header">{{teacher.rank}}</h4>
      <div class="info">
        <img v-lazy="teacher.avatarUrl" />
        <span>{{teacher.name}}</span>
      </div>
      <span>{{teacher.introduce}}</span>
    </div>
    <button @click="goBack" class="study" :style="{ 'margin-bottom': isAndroid ? 0 : '44px'  }">开始学习</button>
  </div>
</template>
<script>
import { get } from '../../utils/request'
import { get as getUser } from '../../utils/token'
import { isAndroid } from '../../utils/utils'
export default {
  data () {
    return {
      isAndroid: isAndroid(),
      chapters: [],
      title: '',
      shareTitle: '',
      students: 0,
      cover: '',
      teacher: {
        avatarUrl: '',
        introduce: '',
        name: '',
        rank: ''
      },
      thought: '',
      details:
        '专题介绍详细文本专题介绍详细文本专题介绍详细文本专题介绍详细文本专题介绍详细文本专题介绍详细文本专题介绍详细文本专题介绍详细文本专题介绍详细文',
      type: ''
    }
  },
  created () {
    this.getRefiningDetails()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    getRefiningDetails () {
      const user = getUser('user')
      const promise = get({
        url: `/course/curriculumDetail/${this.$route.query.id}/${user.id}`
      })
      promise.then(res => {
        const {
          data: { code, detail }
        } = res
        if (Object.is(code, 200)) {
          Object.assign(this, detail)
        }
      })
    }
  },
  computed: {
    getSubsectionCount () {
      const { chapters } = this
      let count = 0
      chapters.forEach(item => {
        item.subsections.forEach(subsection => {
          ++count
        })
      })
      return count
    }
  }
}
</script>
<style lang="scss" scoped>
.introduction {
  overflow-y: scroll;
  max-height: 100vh;
  .img-box {
    width: 100%;
    height: 100vw;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .background {
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vw;
      padding: 41px 24px 0;
      box-sizing: border-box;
      .title {
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 30px;
        display: block;
      }
      .bottom {
        position: absolute;
        left: 24px;
        bottom: 24px;
        display: flex;
        justify-content: space-between;
        width: 87.2%;
        height: 68px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 4px 24px 0px rgba(0, 0, 0, 0.08),
          0px 2px 16px 0px rgba(0, 0, 0, 0.04);
        border-radius: 8px;
        .group {
          width: 50%;
          text-align: center;
          padding: 16px 0;
          position: relative;
          display: flex;
          flex-direction: column;
          span {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(136, 136, 136, 1);
            line-height: 12px;
            width: 100%;
          }
          .number {
            margin-bottom: 4px;
            display: inline-block;
            span {
              font-size: 20px;
              font-weight: 600;
              color: rgba(51, 51, 51, 1);
              line-height: 20px;
              margin-left: 2px;
            }
          }
        }
        &:first-child {
          position: absolute;
          top: calc(50% - 5px);
          right: 0;
          content: "";
          width: 1px;
          height: 10px;
        }
      }
    }
  }
  .panel-box {
    width: 87.2%;
    margin: 36px auto 0;
    font-family: PingFangSC-Medium, PingFang SC;
    span {
      font-size: 16px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(136, 136, 136, 1);
      line-height: 24px;
    }
    .header {
      font-size: 18px;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      margin-bottom: 24px;
      padding-bottom: 9px;
    }
    .info {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      img {
        width: 36px;
        height: 36px;
        border-radius: 50%;
        margin-right: 16px;
      }
      span {
        color: rgba(51, 51, 51, 1);
      }
    }
  }
  .study {
    background: rgba(51, 51, 51, 1);
    border-radius: 28px;
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
    line-height: 16px;
    padding: 13.99px 70px;
    display: block;
    margin: 108px auto 26px;
  }
}
</style>
